module.exports = __webpack_public_path__ + "static/media/03_twitter_image.1bff4286.jpg";